import { Component, inject } from '@angular/core';
import { UserRoleEnum } from 'src/app/enums/enums';
import { UserRoleService } from 'src/app/utils/user-role.service';

type SyncSettingsView = 'menu' | 'epp-integration' | 'user-sync' | 'inventory-sync';

interface SyncSettingsMenuItem {
  key: SyncSettingsView;
  label: string;
  icon: string;
}

@Component({
  selector: 'app-epp-sync-settings',
  templateUrl: './epp-sync-settings.component.html',
  styleUrl: './epp-sync-settings.component.scss',
})
export class EppSyncSettingsComponent {
  private userRoleService = inject(UserRoleService);

  visible = false;
  view: SyncSettingsView = 'menu';

  readonly menuItems: SyncSettingsMenuItem[] = [
    { key: 'epp-integration', label: 'Integración EPP', icon: 'pi pi-link' },
    { key: 'user-sync', label: 'Sincronizar usuarios', icon: 'pi pi-users' },
    { key: 'inventory-sync', label: 'Sincronizar inventario', icon: 'pi pi-box' },
  ];

  get canManageIntegrations(): boolean {
    return this.userRoleService.getRoleEnum() === UserRoleEnum.AdminCompany;
  }

  openSettings(): void {
    this.view = 'menu';
    this.visible = true;
  }

  selectItem(key: SyncSettingsView): void {
    this.view = key;
  }
}
